// @ts-nocheck
import reducer from './userProfileReducer';
import * as selectors from './userProfileSelectors';
import * as actions from './userProfileActions';

export { reducer, selectors, actions };
